import { Link, useLocation } from "react-router-dom";
import { AnchorText } from "../components/StampCard";
import { RungBadge } from "../components/Rung";

export function VouchDonePage() {
  const out = useLocation().state as any;
  if (!out) return <p className="note">Vouch recorded.</p>;
  return (
    <div>
      <h1 data-testid="done-title">{out.edge === "anchor" ? "Anchored" : "Vouch signed"}</h1>
      {out.anchor && <p className="lead" data-testid="done-anchor"><AnchorText a={out.anchor} /></p>}
      {out.rung && <p>The claim now reads <RungBadge rung={out.rung} /></p>}
      <div className="row" style={{ marginTop: 16 }}>
        <Link className="btn primary" to={`/c/${out.claim_id}`} data-testid="done-claim">See the claim</Link>
        <Link className="btn" to="/claim">Claim something of your own</Link>
      </div>
    </div>
  );
}
